/*******************************
 * Dismissables
 ******************************/

const dismissableAttribute = 'data-dismissable'
const dismissedClass = 'dismissed'
const initializedClass = 'initialized'
const dismissables = document.querySelectorAll(`[${dismissableAttribute}]`)

for (let element of dismissables) {
  element.classList.add(initializedClass)

  const key = element.getAttribute(dismissableAttribute)
  const localStorageKey = `dismissable-dismissed__${key}`
  const dismissButton = element.querySelector('.dismiss-button')

  const isDismissed = Boolean(localStorage.getItem(localStorageKey))
  if (isDismissed) element.classList.add(dismissedClass)

  dismissButton.addEventListener('click', () => {
    localStorage.setItem(localStorageKey, true)
    element.classList.add(dismissedClass)
  })
}
